/* global axios */
import ApiClient from './ApiClient';

class DealAttributeGroupsAPI extends ApiClient {
  constructor() {
    super('deal_attribute_groups', { accountScoped: true });
  }

  reorder(ids) {
    return axios.post(`${this.url}/reorder`, { ids });
  }
}

export default new DealAttributeGroupsAPI();
